import { render, staticRenderFns } from "./EditApplicationSectionButton.vue?vue&type=template&id=5c024473&"
import script from "./EditApplicationSectionButton.vue?vue&type=script&lang=ts&"
export * from "./EditApplicationSectionButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports